module.exports = __webpack_public_path__ + "static/media/GH3PlusTwin.53b63a3b.jpg";